export enum CitationType {
  Meeting = 'MEETING',
  Email = 'EMAIL',
  KnowledgeDocument = 'KNOWLEDGE_DOCUMENT',
}
export interface CitationMapping {
  [key: string]: {
    citationType: CitationType;
    citationUuid: number;
  };
}
